import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { getImageUrl, useGetImageUrl } from 'ui-images';
import { DATA_TRANSITIONAL_COMPONENT_ATTRIBUTE } from '../../constants';
import { Image } from '../Image';
import { getBorderStyleProps, getCircleShapeStyleProps, getRoundedShapeStyleProps } from './Illustration.helpers';
import { jsx as _jsx } from "react/jsx-runtime";
export const Illustration = _ref => {
  let {
      disabled = false,
      name,
      height,
      width,
      bordered = false,
      shape = 'default',
      alt = `${name} illustration`,
      isThemeable = false,
      [DATA_TRANSITIONAL_COMPONENT_ATTRIBUTE]: dataComponentAttribute
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, ["disabled", "name", "height", "width", "bordered", "shape", "alt", "isThemeable", DATA_TRANSITIONAL_COMPONENT_ATTRIBUTE].map(_toPropertyKey));
  const heightPx = typeof height === 'number' ? `${height}px` : height;
  const widthPx = typeof width === 'number' ? `${width}px` : width;
  const themeSwitchingImageSrc = useGetImageUrl(name);
  const canvasImageSrc = getImageUrl(name);
  return /*#__PURE__*/_jsx(Image, Object.assign({
    objectFit: "contain",
    src: isThemeable ? themeSwitchingImageSrc : canvasImageSrc,
    alt: alt,
    responsive: false,
    inlineSize: widthPx,
    blockSize: heightPx,
    maxInlineSize: "100%",
    opacity: disabled ? 0.5 : 1
  }, (shape === 'rounded' || shape === 'thumbnail') && getRoundedShapeStyleProps(), shape === 'circle' && getCircleShapeStyleProps(), bordered && getBorderStyleProps(), rest, {
    [DATA_TRANSITIONAL_COMPONENT_ATTRIBUTE]: dataComponentAttribute || 'Illustration'
  }));
};
Illustration.displayName = 'Illustration';